import React, { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import Navbar from "../components/Navbar";
import "../styles/events.css";

export default function TicketSuccess({ cartCount, onCartClick }) {
  const location = useLocation();
  const navigate  = useNavigate();
  const { tickets, eventName, chargeId } = location.state || {};
  const canvasRefs = useRef({});

  const downloadTicket = (ticket) => {
    const canvas = canvasRefs.current[ticket.id];
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `ticket-${(eventName || "event").replace(/\s+/g, "-").toLowerCase()}.png`;
    a.click();
  };

  if (!tickets?.length) {
    return (
      <div className="events-page">
        <Navbar cartCount={cartCount || 0} onCartClick={onCartClick || (() => {})} />
        <p className="events-page__empty">No ticket details to show.</p>
      </div>
    );
  }

  return (
    <div className="events-page">
      <Navbar cartCount={cartCount || 0} onCartClick={onCartClick || (() => {})} />

      <main className="event-detail__main" style={{ textAlign: "center" }}>
        <div style={{ fontSize: 40, marginBottom: 8 }}>🎉</div>
        <h1 className="event-detail__name">You're going!</h1>
        <p style={{ fontSize: 13, color: "#888", marginBottom: 8 }}>{eventName}</p>
        <p style={{ fontSize: 11, color: "#bbb", marginBottom: 28 }}>Reference: {chargeId}</p>

        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {tickets.map((t, i) => (
            <div key={t.id} style={{
              background: "#fff", borderRadius: 14, padding: "24px 20px",
              boxShadow: "0 1px 8px rgba(0,0,0,.06)", display: "flex",
              flexDirection: "column", alignItems: "center", gap: 12,
            }}>
              <QRCodeCanvas
                ref={(el) => { canvasRefs.current[t.id] = el; }}
                value={JSON.stringify({ ticketId: t.id, code: t.code })}
                size={180}
              />
              <p style={{ fontSize: 12, color: "#999" }}>Ticket {i + 1} of {tickets.length}</p>
              <button
                onClick={() => downloadTicket(t)}
                style={{
                  background: "none", border: "1px solid #ddd", color: "#555",
                  padding: "6px 16px", borderRadius: 16, fontSize: 11,
                  cursor: "pointer", fontFamily: "inherit",
                }}
              >
                ↓ Download
              </button>
            </div>
          ))}
        </div>

        <p style={{ fontSize: 12, color: "#888", margin: "24px 0", lineHeight: 1.7 }}>
          Screenshot or save these QR codes — you'll also find them under
          <strong> Profile → My Tickets</strong>. Present one per person at the door.
        </p>

        <button className="event-detail__bar-btn" style={{ position: "static" }} onClick={() => navigate("/profile")}>
          View My Tickets
        </button>
      </main>
    </div>
  );
}
